import React, { useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'src/redux/root-reducer'
import { BankDeleteStyle } from './style'
import { deleteBankAccountAction } from 'src/redux/actions/bankAction'
import { VaultSvg } from 'src/assets'
import { useParams } from 'react-router-dom'
import useSnackbar from 'src/hooks/useSnackBar'
import { useNavigate } from 'react-router'

const BankDelete = ({ myBanks }: any) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  const params = useParams()
  const { id } = params
  const handleDelete = (id: any) => {
    setLoading(true)
    dispatch(deleteBankAccountAction({ id, onSuccess, onError }))
  }
  const myspecificBank = myBanks?.filter((el: any) => {
    return el?.id === id
  })

  const snackbar = useSnackbar()
  const onSuccess = (msg: any) => {
    console.log(msg)
    snackbar.trigger({
      message: msg,
      severity: 'success',
    })
    setLoading(false)
    navigate(-1)
  }

  const onError = (msg: any) => {
    snackbar.trigger({
      message: msg,
      severity: 'error',
    })
    setLoading(false)
  }

  return (
    <BankDeleteStyle>
      {myspecificBank?.map((item: any) => {
        const { account_name, account_number, bank_name, id } = item

        return (
          <div className="bank_delete_container" key={id}>
            <div className="account_details_wrapper">
              <p className="bank_delete_text">Account Name:</p>
              <p className="account_name_text">{account_name.toLowerCase()}</p>
            </div>

            <div className="account_details_wrapper">
              <p className="bank_delete_text">Account Number:</p>
              <p>{account_number}</p>
            </div>

            <div className="account_details_wrapper">
              <p className="bank_delete_text">Bank Name:</p>
              <p>{bank_name}</p>
            </div>

            <div className="delete_bank_action">
              <p onClick={() => handleDelete(id)}>
                {loading ? <p>Deleting...</p> : <p> Delete Bank Account</p>}
              </p>
            </div>
          </div>
        )
      })}
    </BankDeleteStyle>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    myBanks: state.banksResult.getMyBanks?.bank_details,
  }
}

export default connect(mapStateToProps)(BankDelete)
